export enum StudioNotificationState {
	Open,
	Closed,
	Repositioning
}
